/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const InactiveCleanupRunDTOMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * @export
 */
export const InactiveCleanupRunDTOStatusEnum = {
    Running: 'RUNNING',
    Completed: 'COMPLETED',
    Cancelled: 'CANCELLED'
};
/**
 * @export
 */
export const InactiveCleanupRunDTOChannelEnum = {
    Web: 'WEB',
    Extension: 'EXTENSION'
};
/**
 * @export
 */
export const InactiveCleanupRunDTOReasonsEnum = {
    DetailPageRemoved: 'DETAIL_PAGE_REMOVED',
    PricingIssue: 'PRICING_ISSUE',
    OutOfStock: 'OUT_OF_STOCK',
    GpsrMissing: 'GPSR_MISSING',
    ApprovalRequired: 'APPROVAL_REQUIRED',
    Unknown: 'UNKNOWN'
};
/**
 * Check if a given object implements the InactiveCleanupRunDTO interface.
 */
export function instanceOfInactiveCleanupRunDTO(value) {
    return true;
}
export function InactiveCleanupRunDTOFromJSON(json) {
    return InactiveCleanupRunDTOFromJSONTyped(json, false);
}
export function InactiveCleanupRunDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'status': json['status'] == null ? undefined : json['status'],
        'channel': json['channel'] == null ? undefined : json['channel'],
        'reasons': json['reasons'] == null ? undefined : json['reasons'],
        'minInactiveDays': json['minInactiveDays'] == null ? undefined : json['minInactiveDays'],
        'expectedCount': json['expectedCount'] == null ? undefined : json['expectedCount'],
        'candidateCount': json['candidateCount'] == null ? undefined : json['candidateCount'],
        'requestedCount': json['requestedCount'] == null ? undefined : json['requestedCount'],
        'skippedExistingJob': json['skippedExistingJob'] == null ? undefined : json['skippedExistingJob'],
        'skippedSincePreview': json['skippedSincePreview'] == null ? undefined : json['skippedSincePreview'],
        'waitingCount': json['waitingCount'] == null ? undefined : json['waitingCount'],
        'submittedCount': json['submittedCount'] == null ? undefined : json['submittedCount'],
        'succeededCount': json['succeededCount'] == null ? undefined : json['succeededCount'],
        'failedCount': json['failedCount'] == null ? undefined : json['failedCount'],
        'cancelledCount': json['cancelledCount'] == null ? undefined : json['cancelledCount'],
        'estimatedMinutes': json['estimatedMinutes'] == null ? undefined : json['estimatedMinutes'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'completedAt': json['completedAt'] == null ? undefined : (new Date(json['completedAt'])),
    };
}
export function InactiveCleanupRunDTOToJSON(json) {
    return InactiveCleanupRunDTOToJSONTyped(json, false);
}
export function InactiveCleanupRunDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'marketplace': value['marketplace'],
        'status': value['status'],
        'channel': value['channel'],
        'reasons': value['reasons'],
        'minInactiveDays': value['minInactiveDays'],
        'expectedCount': value['expectedCount'],
        'candidateCount': value['candidateCount'],
        'requestedCount': value['requestedCount'],
        'skippedExistingJob': value['skippedExistingJob'],
        'skippedSincePreview': value['skippedSincePreview'],
        'waitingCount': value['waitingCount'],
        'submittedCount': value['submittedCount'],
        'succeededCount': value['succeededCount'],
        'failedCount': value['failedCount'],
        'cancelledCount': value['cancelledCount'],
        'estimatedMinutes': value['estimatedMinutes'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'completedAt': value['completedAt'] == null ? undefined : ((value['completedAt']).toISOString()),
    };
}
